module.exports = __webpack_public_path__ + "img/cortona-students-in-square.8eb10e89.jpg";